<template>
  <AnalyticsWidget
    title="Customer Aged Balances"
    subTitle="Breakdown of customer outstanding balance"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    :loading="loading"
  >
    <div class="row no-gutters h-100">
      <div class="col-2 p-2">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue title="Average Days to Pay">
              {{formatDecimal(paidInvoiceInfo.avgDayPaidDiff)}}
              <template v-slot:info>Based on {{paidInvoiceInfo.invoiceCount}} invoice{{displayCountPlural(paidInvoiceInfo.invoiceCount)}} that were paid in the last 90 days</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue title="Quickest Paid">
              {{paidInvoiceInfo.minDayPaidDiff}} Day{{displayCountPlural(paidInvoiceInfo.minDayPaidDiff)}}
              <template v-slot:info>Based on {{paidInvoiceInfo.invoiceCount}} invoice{{displayCountPlural(paidInvoiceInfo.invoiceCount)}} that were paid in the last 90 days</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue title="Slowest Paid">
              {{paidInvoiceInfo.maxDayPaidDiff}} Day{{displayCountPlural(paidInvoiceInfo.minDayPaidDiff)}}
              <template v-slot:info>Based on {{paidInvoiceInfo.invoiceCount}} invoice{{displayCountPlural(paidInvoiceInfo.invoiceCount)}} that were paid in the last 90 days</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
      </div>
      <div class="col-10">
        <LoadingPanel :loading="loading" />
        <ChartBar
          :series="customerBalanceData.series"
          :xAxis="customerBalanceData.xAxis"
          :yAxis="customerBalanceData.yAxis"
          :legend="customerBalanceData.legend"
          :options="customerBalanceData.options"
        />
      </div>
    </div>
    
  </AnalyticsWidget>
</template>


<script>
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import ChartBar from '@/components/charts/chartBar'

export default {
  name: 'CustomerAgedBalanceChartWidget',
  components: {
    AnalyticsDashboardValueRow,
    AnalyticsDashboardValue,
    AnalyticsWidget,
    ChartBar
  },
  props: {
    contactId: Number,
    gridWidth: Number,
    gridHeight: Number
  },
  data() {
    return {
      loading: false,

      paidInvoiceInfo: {
      },
      summaryData: {},

      customerBalanceData: {
        series: [],
        xAxis: {},
        yAxis: {},
        legend: {},
        options: {}
      },
    }
  },
  computed: {
    hasContact() {
      return !!this.contactId
    }
  },
  watch: {
    contactId: function() {
      this.requestChartData()
    }
  },
  mounted() {
    this.requestChartData()
  },
  methods: {
    requestChartData() {
      let filterData = {
        contactId: this.contactId
      }

      if(!this.contactId)
        return

      this.loading = true
      this.$apiService.analyticsService.getAccountsAgedTrialBalance(filterData)
      .then(response => {
        var balanceData = response.data

        this.summaryData = balanceData

        if(balanceData.contactList.length == 1) {
          this.paidInvoiceInfo = balanceData.contactList[0].paidInvoiceSummary
        }

        this.customerBalanceData.xAxis = {
          data: ['Current', 'Overdue 0-30', 'Overdue 30-60', 'Overdue 60-90', 'Overdue 90+']
        }
        this.customerBalanceData.yAxis = [
          { type: 'value' },
          { type: 'value', alignTicks: true }
        ]
        this.customerBalanceData.series = [
          {
            type: 'bar',
            name: 'Outstanding',
            data: [
              { value: balanceData.totalOutstandingCurrent, itemStyle: { color: '#91CC75' } },
              { value: balanceData.totalInvoiceDue0to30, itemStyle: { color: '#73C0DE' } },
              { value: balanceData.totalInvoiceDue30to60, itemStyle: { color: '#5470C6' } },
              { value: balanceData.totalInvoiceDue60to90, itemStyle: { color: '#FAC858' } },
              { value: balanceData.totalInvoiceDue90Plus, itemStyle: { color: '#EE6666' } }
            ],
            tooltip: {
              valueFormatter: (value) => {
                return this.formatCurrency(value);
              }
            }
          }, {
            type: 'line',
            name: 'Invoice Count',
            yAxisIndex: 1,
            itemStyle: { color: '#EA7CCC' },
            data: [
              balanceData.totalInvoiceCurrentCount,
              balanceData.totalInvoiceDue0to30Count,
              balanceData.totalInvoiceDue30to60Count,
              balanceData.totalInvoiceDue60to90Count,
              balanceData.totalInvoiceDue90PlusCount
            ]
          }
        ]
        this.customerBalanceData.options.legend = {
          data: []
        }
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>